<template>
    <div id="tab">
        <el-tabs type="border-card">
            <el-tab-pane label="拍照类型">
                <el-card class="box-card-query" shadow="never">
                    <el-form :inline="true" size="small">
                        <el-form-item label="查询条件">
                            <el-input placeholder="输入拍照类型名称/简称查询" v-model="queryInfo.keyWords" clearable></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="getTableData">查询</el-button>
                        </el-form-item>
                        <el-form-item style="float: right;" v-if="tableData.length < 9">
                            <el-button @click="addPicType">添加</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>
                <div class="table" v-loading="tableLoading">
                    <el-table ref="table" :data="tableData" border stripe height="100%" max-height="100%">
                        <el-table-column type="index" width="55" align="center"></el-table-column>
                        <el-table-column prop="picType" label="拍照类型名称"></el-table-column>
                        <el-table-column prop="isRequired" label="是否必须拍照">
                            <template slot-scope="{ row }">
                                {{row.isRequired == 'Y' ? '是' : '否'}}
                            </template>
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="{ row }">
                                <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                                    <el-button size="mini" type="text" icon="iconfont icon-bianji" @click="editData(row)"></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" v-if="row.isDelete == 'Y'" effect="dark" content="删除" placement="top">
                                    <el-button size="mini" v-if="row.isDelete == 'Y'" type="text" icon="el-icon-delete" @click="deleteData(row)"></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
        </el-tabs>
        <el-dialog width="500px" :title="isEdit ? '编辑拍照类型' : '添加拍照类型'" :visible.sync="dialogFormVisible" @close="dialogFromClose" :close-on-click-modal="false" destroy-on-close>
            <el-form ref="dialogFromRef" :model="dialogFrom" label-width="120px" :rules="dialogFromRules">
                <el-form-item label="拍照类型" prop="picType">
                    <el-input v-model="dialogFrom.picType"></el-input>
                </el-form-item>
                <el-form-item label="是否必须拍照" prop="isRequired">
                    <el-radio-group v-model="dialogFrom.isRequired">
                        <el-radio label="Y">是</el-radio>
                        <el-radio label="N">否</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSubmit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    data() {
        return {
            queryInfo: {
                keyWords: ''
            },
            tableLoading: false,
            tableData: [],
            dialogFormVisible: false,
            isEdit: false,
            dialogFrom: {
                id: '',
                picType: '',
                isRequired: 'N'
            },
            dialogFromRules: {
                picType: [
                    { required: true, message: '请输入拍照类型', trigger: 'blur' },
                    { min: 0, max: 50, message: '长度在 0 到 50 个字符', trigger: 'blur' },
                    {
                        type: 'string',
                        required: true,
                        pattern: /^[\u4e00-\u9fa5a-zA-Z\d\(\)（）\_\-\.\*]+$/,
                        message: '请输入正确的拍照类型',
                        trigger: ['change', 'blur']
                    }
                ]
            }
        }
    },
    created() {
        this.getTableData()
    },
    mounted() {
        this.$nextTick(() => {
            this.$refs.table.doLayout()
        })
    },
    methods: {
        async getTableData() {
            this.tableLoading = true
            const { data: res } = await this.$http.post('/Account/salStorestatusPictype/selectSalStorestatusPictypeList.html', this.Qs.stringify({
                keyWords: this.queryInfo.keyWords
            }))
            this.tableLoading = false
            if (res.code != 'success') return this.$message.error(res.message)
            let { total, data } = JSON.parse(res.result)
            this.tableData = JSON.parse(data)
        },
        onSubmit() {
            this.$refs['dialogFromRef'].validate(async (valid) => {
                if (valid) {
                    const { data: res } = await this.$http.post(this.isEdit ? '/Account/salStorestatusPictype/updateSalStorestatusPictype.html' : '/Account/salStorestatusPictype/addSalStorestatusPictype.html', this.Qs.stringify(this.dialogFrom))
                    if (res.code != 'success') return this.$message.error(res.message)
                    this.$message.success(res.message)
                    this.dialogFormVisible = false
                    this.getTableData()
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async editData(row) {
            this.dialogFrom = { ...row }
            this.isEdit = true
            this.dialogFormVisible = true
            this.queryInfo.keyWords = ''
        },
        addPicType() {
            this.dialogFormVisible = true
            this.queryInfo.keyWords = ''
            delete this.dialogFrom.id
        },
        async deleteData({ id }) {
            const confirmResult = await this.$confirm('此操作为删除操作, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)
            if (confirmResult !== 'confirm') return this.$message.info('取消删除')
            const loading = this.$loading({
                lock: true,
                text: '删除中，请耐心等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            const { data: res } = await this.$http.post('/Account/salStorestatusPictype/deleteSalStorestatusPictype.html', this.Qs.stringify({ id }))
            loading.close()
            if (res.code != 'success') return this.$message.error(res.message)
            this.$message.success(res.message)
            this.queryInfo.keyWords = ''
            this.getTableData()
        },
        dialogFromClose() {
            console.log(111)
            this.dialogFrom = {
                id: '',
                picType: '',
                isRequired: 'N'
            }
            this.isEdit = false
        }
    }
}
</script>
<style lang="less" scoped>
.el-tabs {
    height: 100%;
    display: flex;
    flex-flow: column;

    ::v-deep .el-tabs__item {
        height: 34px;
        line-height: 34px;
    }

    ::v-deep .el-tabs__content {
        flex: 1;
        padding-top: 0;
        box-sizing: border-box;

        .el-tab-pane {
            height: 100%;
            display: flex;
            flex-flow: column;

            .box-card-query {
                flex-shrink: 0;

                .el-card__body {
                    padding: 12px;

                    .el-form {
                        .el-form-item {
                            margin-bottom: 0;
                        }
                    }
                }
            }

            .table {
                flex: 1;

                .el-icon-delete {
                    font-size: 16px;
                }

                .el-button--text {
                    padding-top: 0;
                    padding-bottom: 0;
                }

                .el-table {

                    th,
                    td {
                        padding: 6px 0;

                        .cell {
                            font-size: 14px;
                            padding: 0 auto;
                        }
                    }
                }
            }

            .el-pagination {
                margin-top: 8px;
            }
        }
    }
}
</style>